<template>
<file-layout @share="onShare" :show-header="isPublic" :file-name="this.metadata ? this.metadata?.fileName : ''" :allow-share="showShareButton">
    <div class="zip-preview" v-show="isZip">
      <svg-icon icon-class="cloud-zip" class="zip-icon"></svg-icon>
      <div class="title">{{$t("该文件不支持预览#!!!#src/pages/H5/Cloud/components/OfficeView.vue_1")}}</div>
      <div class="tip" v-if="auth !== 'READ'">{{$t("您可以下载后查看#!!!#src/pages/H5/Cloud/components/OfficeView.vue_1")}}</div>
      <div>
        <button @click="handleOpen" v-if="isPcMode && isLogin" class="preview-button common-button">{{$t("在线预览#!!!#src/pages/H5/Cloud/components/OfficeView.vue_1")}}        </button>
        <button @click="onDownload" v-if="auth !== 'READ' && !isSafe" class="download-button common-button">{{$t("下载到本地#!!!#src/pages/H5/Cloud/components/OfficeView.vue_1")}}        </button>
      </div>
    </div>
    <div v-show="!isZip" :class="{ 'file-content': true, 'file-content-view': isViewPermission }">
      <div v-if="isPc" class="wps-content">
        <div class="wps-office" ref="wps"></div>
      </div>
      <div v-else class="wps-mobile-content">
        <div class="wps-office-mobile" ref="wps"></div>
      </div>
    </div>
  </file-layout>
</template>

<script>
import { intl } from 'tci18n-vue2'
import cookies from "js-cookie";
import TocaSDK from "toca-sdk";
import semver from "semver";
import Debug from "@/core/h5/debug/index";
import FileLayout from "@/components/h5/Layout";
import { getPreviewUrl, getEditUrl, postFileComment, getSubPreviewUrl } from "@/api/h5/wps";
import OpenSDK from "@/core/h5/wps/web-office-sdk-v1.1.19.js";
import Cookies from "js-cookie";
import {
  WPS_HIDE_COMPONENTS,
  MOBILE_WPS_HIDE_COMPONENTS } from
"@/constants/file";
import { getQueryParameters } from "@/utils/index";
import { mapState } from "vuex";
import utils from "@/core/h5/utils";

const debug = new Debug();

export default {
  props: {
    auth: {
      type: String
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    rootId: {
      type: String
    },
    fileId: {
      type: String
    },
    metadata: {
      type: Object
    },
    isPublic: {
      type: Boolean
    },
    isSafe: {
      type: Boolean,
      default: false
    },
    memberUniqueId: {
      type: String
    },
    is_inTocaApp: {
      type: Boolean
    },
    belongingFileId: {
      type: String,
      default: ""
    }
  },

  watch: {},

  data() {
    return {
      isZip:
      utils.isZip(this.metadata?.fileName || "") &&
      !(this.$route.query?.type == "openZip"),
      isPreviewType: false,
      isReady: false,
      version: null,
      wpsSDK: null,
      app: null,
      showTip: false,
      isPc: true,
      spaceId: Cookies.get("spaceId") || null,
      editMode: false,
      // w 文档 s 表格 p 演示文档
      fileType: ""
    };
  },

  created() {},

  components: {
    FileLayout
  },

  methods: {
    async handleSave() {
      // const result = await this.wpsSDK.save()
      // return result
      switch (this.fileType) {
        // 文档
        case "w":
          return await this.app.ActiveDocument.Save();
        // 表格
        case "s":
          return await this.app.ActiveWorkbook.Save(true);
        // ppt
        case "p":
          return await this.app.ActivePresentation.Save();
        default:
          break;
      }
    },
    handleOpen() {
      const { origin, pathname } = window.location;
      window.open(origin + pathname + "" + `?fid=${this.fileId}&type=openZip`);
      return;
      this.isZip = false;
    },
    onDownload() {
      this.$emit("download", this.fileId, false);
    },
    async handlePrint() {
      await this.app.CommandBars("TabPrintPreview").Execute();
    },
    async handleHistory() {
      await this.app.Public.Cooperation.SwitchVersionPanel();
    },
    async handleWPSBarExecute(type) {
      // type: TabStartTab、TabInsertTab、TabDataTab、TabFormulaTab、TabCooperationTab、TabPageTab、TabReviewWord、TabToolsTab
      await this.app.CommandBars(type).Execute();
    },
    async handleExport(type) {
      let data = {};
      switch (this.fileType) {
        // 文档
        case "w":
          // 导出pdf
          if (type === "pdf") {
            data = await this.app.ActiveDocument.ExportAsFixedFormat();
          }
          // 导出图片
          type === "image" && (
          data = await this.app.ActiveDocument.ExportAsFixedFormat({
            ExportFormat: this.app.Enum.WdExportFormat.wdExportFormatIMG, // 或者传参 19
            Combine2LongPic: true
          }));
          break;
        // 表格
        case "s":
          data = await this.app.ActiveWorkbook.ExportAsFixedFormat({
            Type: this.app.Enum.XlFixedFormatType.xlTypeIMG
          });
          break;
        // ppt
        case "p":
          type == "pdf" && (
          data = await this.app.ActivePresentation.ExportAsFixedFormat());

          type == "image" && (
          data = await this.app.ActivePresentation.ExportAsFixedFormat({
            FixedFormatType: this.app.Enum.PpFixedFormatType.
            ppFixedFormatTypeIMG,
            Combine2LongPic: true,
            From: 0,
            To: 1
          }));
          break;
        // case 'f':
        //   data = await this.app.ActivePDF?.ExportAsFixedFormat({
        //     FixedFormatType: this.app.Enum.FixedFormatType.TypeIMG,
        //     Combine2LongPic: true
        //   });
        //   break;
        default:
          break;
      }
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = data.url;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      setTimeout(() => document.body.removeChild(link), 200);
    },
    async openWps() {
      debug.log("准备打开WPS文件");
      try {
        if (TocaSDK.Environment.isInElectron()) {
          debug.log("当前在 同程管家 内部打开");
          const system = new TocaSDK.System();
          this.version = await system.getVersion();
          debug.log("客户端版本：", this.version);
        }
      } catch (err) {
        debug.error(intl.$t("检查环境，获取客户端版本号发生了异常：#!!!#src/pages/H5/Cloud/components/OfficeView.vue_1"), err);
      }
      const editMode = this.auth === "ALL" || this.auth === "WRITE";
      const isPreviewType = utils.isWpsPreview(this.metadata.fileName);
      this.isPreviewType = isPreviewType;
      const combMode = editMode && !isPreviewType;
      this.editMode = combMode;
      const isSub = this.belongingFileId && this.belongingFileId.length > 0;
      //   const func = combMode ? getEditUrl : (isSub === true ? getSubPreviewUrl : getPreviewUrl);
      debug.log(`当前是否是编辑模式：${combMode}`);
      //   const e = await func(this.fileId);
      let e = null;
      if (combMode === true) {
        e = await getEditUrl(this.fileId);
      } else {
        if (isSub === true) {
          e = await getSubPreviewUrl(this.fileId, this.belongingFileId);
        } else {
          e = await getPreviewUrl(this.fileId);
        }
      }
      const { code, data } = e;
      if (code == 180) {
        this.$emit("handleGoDownload");
      }
      if (code != 200) return;
      const { url } = data;
      debug.log(`获取 WPS 的地址：${url}`);
      const { type = "" } = this.$route.query;
      const isSimple = this.isPc ?
      {
        isShowTopArea: true, // 隐藏顶部区域（头部和工具栏）
        isShowHeader: false // 隐藏头部区域
      } :
      {
        acceptVisualViewportResizeEvent: true
      };
      const options = {
        url: url,
        mount: this.$refs.wps,
        commonOptions: isSimple,
        mobile: {
          isOpenIntoEdit: type === "fileCreate" ? true : false // （Mobile）要有编辑权限，移动端打开时是否进入编辑
        },
        wordOptions: {
          mobile: {
            isOpenIntoEdit: type === "fileCreate" ? true : false, // （Mobile）要有编辑权限，移动端打开时是否进入编辑
            showEditToolbarOnKeyboard: true
          }
        },
        pptOptions: {
          mobile: {
            isOpenIntoEdit: type === "fileCreate" ? true : false // （Mobile）要有编辑权限，移动端打开时是否进入编辑
          }
        },
        getClipboardData: async () => {
          // console.log('pc fuzhi');
          return new Promise((resolve) => {
            window._toca_birdge_util.get_clipboard({
              callback: (resp) => {
                resolve({
                  text: resp?.data, // text 格式数据
                  updateExternal: true // 是否从外部粘贴数据，为 false 则从内部剪切板获取
                });
              }
            });
          });
        },
        onHyperLinkOpen: ({ linkUrl }) => {
          if (this.isPcMode) {
            return window.open(linkUrl);
          }
          // 自身业务处理
          if (linkUrl.includes(process.env.VUE_APP_BASE_URL)) {
            const { fid = "" } = getQueryParameters(linkUrl);
            if (fid === this.fileId) return; //自己的文件不跳转
            if ((this.is_Android || this.is_iOS) && this.is_inTocaApp) {
              const cloudLink = `toca://clouddisk/?fileId=${fid}`;
              window.open(cloudLink);
              return;
            }
            this.$router.push({
              name: "home",
              query: {
                fid
              }
            });
            return;
          }
          window.location.href = linkUrl;
        }
      };

      if (this.isPcMode) {
        options.getClipboardData = null;
      }

      if (editMode) {
        const token = cookies.get("token");
        if (token && token.length > 0) {
          debug.log("获取了token，", token.length);
        }
        options.setToken = {
          token: token,
          timeout: 30 * 60 * 1000
        };
        options.refreshToken = () => {
          return {
            token: token,
            timeout: 30 * 60 * 1000
          };
        };
      }
      this.init(options, isPreviewType);
    },
    async init(options, isPreviewType) {
      const regex = /weboffice\/office\/(.*?)\//;
      const match = options.url.match(regex);
      if (match) {
        this.fileType = match?.[1];
        this.$emit("handleInitExportOptions", match[1]);
        if (match[1] == "w" && !!this.spaceId && this.editMode) {
          this.showTip = true;
        }
      }

      const sdk = await OpenSDK.config(options);
      this.wpsSDK = sdk;
      if (!isPreviewType) {
        debug.log("初始化 OpenSDK");
        sdk.on("opendocStage", (e) => {
          debug.log("opendocStage", e);
        });
        sdk.on("error", (err) => {
          debug.log(`WPS 初始化发生错误：`, err);
        });
        debug.log("准备调用 wps.ready()");
        await sdk.ready();
      }

      debug.log("调用 wps.ready() 完成");
      this.initWpsIframe();
      this.isReady = true;
      window.addEventListener("resize", this.initWpsIframe);
      const app = sdk.Application;
      this.app = app;
      if (this.is_inTocaApp && this.fileType == "w") {
        app.ActiveDocument.ActiveWindow.View.ShowComments = false;
        app.ActiveDocument.ActiveWindow.DocumentMap = false;
      }
      await this.initWPSHeader(app, sdk);

      if (!!this.spaceId) {
        const query = this.$route.query;
        const { fid = "" } = query;
      }

      const query = this.$route.query;
      const { fid = "" } = query;

      const memberUniqueId = this.memberUniqueId;

      if (!this.isPreviewType) {
        this.handleComment(app);
      }
    },
    async handleComment(app) {
      switch (this.fileType) {
        // 文档
        case "w":
          // word 评论
          app.Sub.AddComment = async (data) => {
            // 获取全文评论
            const operatorsInfo = await app.ActiveDocument.GetComments({
              Offset: 0,
              Limit: 200
            });
            let rcCommentInfo;
            // console.log('全文评论', operatorsInfo);
            if (data?.replyCommentId) {
              rcCommentInfo = operatorsInfo.find(
                (item) => item.commentId === data?.replyCommentId
              );
              // console.log('评论数据为', data);
              // console.log('被评论数据为', rcCommentInfo);
            } else {

              // console.log('评论数据为', data);
            }};
          break;
        // 表格
        case "s":
          break;
        // ppt
        case "p":
          break;
        case "f":
          break;
        default:
          break;
      }
    },
    async initWPSHeader(app, sdk) {
      if (!this.isPreviewType) {
        this.hideWpsComponent(app);
      }

      const { type = "" } = this.$route.query;
      const isCreate = type == "fileCreate";
      if (!this.isPc) {
        // 切换到阅读模式
        if (this.fileType == "w" && !isCreate) {
          await app.ActiveDocument.SwitchToReadMode();
        }
        return;
      }

      // 获取头部高度 component-header-wrap
      // 设置默认连页视图
      if (this.fileType == "w" && !this.isPreviewType) {
        if (isCreate) {
          await app.ActiveDocument.SwitchTypoMode(true);
        }

        // 显示文件名栏
        await app.ActiveDocument.SwitchFileName(false);
      }

      if (!this.isPreviewType) {
        // 获取file 保存状态
        sdk.ApiEvent.AddApiEventListener("fileStatus", (data) => {
          this.$emit("handleFileStatus", data);
        });
      }
    },
    async hideWpsComponent(app, sdk) {
      let data = this.isPcMode ?
      WPS_HIDE_COMPONENTS :
      MOBILE_WPS_HIDE_COMPONENTS;
      for (let x of data) {
        const component = await app.CommandBars(x);
        component.Visible = false;
      }
    },
    async getRange() {
      await this.app.ActiveDocument.ActiveWindow.Selection.InsertAfter({
        Text: "Text"
      });
      return;
    },
    onShare() {
      if (!this.showShareButton) return;
      const file = new TocaSDK.File();
      file.showPermission(this.fileId, "share");
    },
    async insertCallback(message, params) {
      // 选区对象
      try {
        await this.app.ActiveDocument.ActiveWindow.Selection.InsertAfter({
          Text: message
        });
      } catch (err) {}
    },
    async insertDeltaCallback(message, params) {
      // 选区对象

      try {
        // 选区对象
        const selection = await this.app.ActiveDocument.ActiveWindow.Selection;
        // Range 对象
        const range = await selection.Range;
        // 获取选中文本的起点位置
        const start = await range.Start;
        const end = (await range.End) + 1;

        let content = message;
        const regex = /<ol>([\s\S]*?)<\/ol>/g;
        content = content.replace(regex, (match, p1) => {
          const pRegex = /<p>([\s\S]*?)<\/p>/g;
          const pContent = p1.replace(pRegex, "$1");
          return `<ol>${pContent}</ol>`;
        });
        // if (!!message.match('<ol>') || !!message.match('<ul>')) {
        //   // 处理p标签
        //   const parseStr = message.replace(
        //     /<(ul|ol)[^>]*>[\s\S]*?<\/\1>/g,
        //     match => {
        //       return match.replace(/<p[^>]*>([\s\S]*?)<\/p>/g, '$1');
        //     }
        //   );
        //   content = `<ol>
        //     ${parseStr.replace(/<ol(.*?)>([\s\S]*?)<\/ol>/g, '$2')}
        //   </ol>`;
        // }
        const emoReg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;

        content = content.replace(emoReg, intl.$t("【表情】#!!!#src/pages/H5/Cloud/components/OfficeView.vue_1"));
        content = intl.$t(`<html><body style='font-family: 'Microsoft YaHei', 微软雅黑;'>{content}</body></html>#!!!#src/pages/H5/Cloud/components/OfficeView.vue_1`, { content: content });

        const insertHTML = await this.app.ActiveDocument.Range(
          start,
          end - 1
        ).PasteHtml({
          HTML: content
        });
      } catch (err) {}
    },
    initWpsIframe(event) {
      if (this.isPc && this.isPreviewType) {
        const wpsIframe = this.$refs.wps.querySelector("iframe");
        const wpsUrl = "https://toca-wps.17u.cn";
        wpsIframe.allow = `clipboard-read self ${wpsUrl}; clipboard-write self ${wpsUrl};`;
        const tmpUrl = wpsIframe.src;
        wpsIframe.src = tmpUrl;
      }
    },
    initMode() {
      const agent = navigator.userAgent.toLowerCase();

      if (
      agent.match(/microMessenger/i) === "micromessenger" ||
      /android|webos|iphone|ipod|balckberry/i.test(agent))
      {
        return this.isPc = false;
      }
      return this.isPc = true;
    }
  },

  mounted() {
    window._toca_birdge_util.showOrHideInputToolBar({
      parms: { show: "0" },
      callback: (resp) => {
        console.log("showOrHideInputToolBar resp", resp);
      }
    });
    this.openWps();
  },

  created() {
    this.initMode();
  },

  destroyed() {
    window?.removeEventListener("resize", this.initWpsIframe);
    window._toca_birdge_util.showOrHideInputToolBar({
      parms: { show: "0" },
      callback: (resp) => {
        console.log("showOrHideInputToolBar resp", resp);
      }
    });
  },

  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
      currentUser: (state) => state.currentUserInfo
    }),
    showShareButton() {
      if (this.auth !== "ALL") return false;
      if (!TocaSDK) return false;
      if (this.version == null) return false;
      if (semver.lt(this.version, "4.20.0")) return false;
      return TocaSDK.Environment.isInElectron();
    },
    isViewPermission() {
      return this.auth === "READ" || this.auth === "READ_DOWNLOAD";
    }
  }
};
</script>

<style lang="scss">
.wps-office {
  iframe {
    height: 100% !important;
  }
}
.file-content-view {
  box-sizing: border-box;
}

.file-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  .wps-mobile-content {
    display: block;
    width: 100%;
    height: 100%;
  }

  .wps-content {
    overflow-x: auto;
    flex: 1;
    position: relative;
  }

  .wps-content::-webkit-scrollbar {
    display: none;
  }

  .wps-office {
    width: 100%;
    height: 100%;
  }

  .wps-office-mobile {
    width: 100%;
    height: 100%;
  }
}

.zip-preview {
  width: 464px;
  height: 297px;
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  .zip-icon {
    width: 72px;
    height: 72px;
    margin-bottom: 16px;
  }

  .title {
    font-family: "PingFang SC", sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: #121317;
    letter-spacing: 0;
    margin-bottom: 8px;
  }

  .tip {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #646573;
    letter-spacing: 0;
    margin-bottom: 40px;
  }

  .common-button {
    width: 138px;
    height: 36px;
    border: 1px solid #e8e9ee;
    border-radius: 6px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
  }

  .preview-button {
    color: #222329;
    background: #ffffff;
    margin-right: 16px;
  }

  .download-button {
    color: #ffffff;
    background: #5c70ff;
  }
}
</style>
